import bootstrap from 'bootstrap';

class Accordion {
    constructor() {
        this.init();
    }
    
    init() {
       
    }

    start(){
        const urlHash = window.location.hash;
        if(urlHash){
            openAccordion();
        }

        function openAccordion(){
            const thisAccordion: HTMLElement = document.querySelector(window.location.hash + ' .accordion-header');
            if(thisAccordion != null){
                const section = thisAccordion.offsetParent as HTMLElement;
                window.scrollTo(0, (section.offsetTop + thisAccordion.offsetTop - 140));
                thisAccordion.querySelector('button').click();
            }
        }

        let aHrefs = document.querySelectorAll('[href^="#-acco"]');
        if(aHrefs !== null){
            aHrefs.forEach((ele : HTMLAnchorElement)=>{
                // console.log(ele);
                if(ele !== null)
                {
                    ele.addEventListener("click", () =>{
                        let ahref = new URL(ele.href);
                        let accordionElHash = document.querySelector(ahref.hash);
                        let accordionBtn = accordionElHash.querySelector("button");
                        if(accordionBtn){
                            accordionBtn.click();
                        }
                    });
                }
            })
        }

    }
}

export default Accordion;